import { TABLA_CONSULTA_CODIGO_CUPO_PARA_ACTOR } from '../../../../../config/tables'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'
import { TablaConsultaCodigoCupoParaActorService } from '../servicio/tabla_consulta_cdigo_cupo_para_actor'
import { COLUMNS_CONSULTA_CODIGO_CUPO_PARA_ACTOR, COLUMNS_CONSULTA_CODIGO_CUPO_PARA_ACTOR_TO_PRINT } from './constantesConsultaCodigoCupoParaActor'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CONSULTA_CODIGO_CUPO_PARA_ACTOR
    })
    TablaConsultaCodigoCupoParaActorService.getDataConsultaCodigoCupoParaActor().then(callback)
    function callback (data) {
      console.log(data)
      const customToolbar = pdfCustomToolbarGenerator(
        'Consulta Codigo Cupo Para Actor',
        data,
        COLUMNS_CONSULTA_CODIGO_CUPO_PARA_ACTOR_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CONSULTA_CODIGO_CUPO_PARA_ACTOR,
          data: data,
          title: `Consulta Codigo Cupo Para Actor`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false, rowsPerPage: 50, rowsPerPageOptions: [50, 100] }
        },
        id: TABLA_CONSULTA_CODIGO_CUPO_PARA_ACTOR
      })
    }
  }
}
